import moment from 'moment';
import { useTranslation } from 'react-i18next';
import React, { useMemo, useState } from 'react';
import { StickyTable } from 'datastake-daf/dist/components';
import Island from './island';
import { mapMeasures, measuresColumns as columns } from './helpers';

export default function CompletedMeasures({
  measures = [],
  measuresValue = [],
  events = [],
  linkToEvent = () => '',
}) {
  const { t } = useTranslation();
  const [toggledKeys, setToggledKeys] = useState([]);

  const data = useMemo(() => {
    return mapMeasures({
      measures,
      measuresValue: measuresValue,
      status: 'completed',
      events,
    })
  }, [measures, measuresValue, events]);

  const lastUpdate = useMemo(() => {
    let all = [];

    (data || []).forEach((d) => {
      all.push(d.createdAt);
    });

    all = all.sort((a, b) => moment(b).diff(moment(a)));

    if (all[0]) {
      return all[0];
    }

    return null;
  }, [data]);

  const legend = useMemo(() => ({
    completed: {
      label: t('Completed'),
      value: data.length,
      color: '#52C41A',
    },
  }), [data, t]);

  const onToggleChanged = (val) => {
    setToggledKeys(val);
  };

  return (
    <Island
      headerText={t('Completed Measures')}
      legend={legend}
      mT
      t={t}
      lastUpdate={lastUpdate}
    >
      <div style={{ overflowX: 'auto' }}>
        <StickyTable
          rowKey="id"
          dataSource={data}
          columns={columns(t, linkToEvent)}
          size="small"
          expandable={{
            expandedRowKeys: toggledKeys,
            onExpandedRowsChange: (rows) => onToggleChanged(rows),
            rowExpandable: false,
          }}
          rowClassName={(rec) => toggledKeys.includes(rec.key) ? 'expanded' : ''}
        />
      </div>
    </Island>
  );
}
